import useKlydoMutation, {
  UseKlydoMutationOptions,
} from "../../../../components/hooks/useKlydoMutation";
import adminApiClient from "../../../../api/admin";

const useSignOutUserMutation = (
  options?: UseKlydoMutationOptions<void, string>,
) => {
  return useKlydoMutation({
    mutationKey: ["sign-out-user"],
    mutationFn: (userId: string) => adminApiClient.signOutUser(userId),
    ...options,
  });
};

export default useSignOutUserMutation;
